import { render, staticRenderFns } from "./TextAlfaNumeric.vue?vue&type=template&id=54570b74"
import script from "./TextAlfaNumeric.vue?vue&type=script&lang=js"
export * from "./TextAlfaNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports